/** Pointer down/up handlers for long-press detection. */
import { useCallback } from 'react';

export function useLongPressDownUpHandlers({
  onLongPress,
  onClick,
  ms,
  timerRef,
  startPointRef,
  isLongPressTriggeredRef,
  isMovementExceededRef,
}) {
  const onPointerDown = useCallback(
    (e) => {
      startPointRef.current = { x: e.clientX, y: e.clientY };
      isLongPressTriggeredRef.current = false;
      isMovementExceededRef.current = false;

      timerRef.current = setTimeout(() => {
        if (!isMovementExceededRef.current) {
          onLongPress(e);
          isLongPressTriggeredRef.current = true;
        }
      }, ms);
    },
    [
      onLongPress,
      ms,
      timerRef,
      startPointRef,
      isLongPressTriggeredRef,
      isMovementExceededRef,
    ],
  );

  const onPointerUp = useCallback(
    (e) => {
      clearTimeout(timerRef.current);
      if (!isLongPressTriggeredRef.current && !isMovementExceededRef.current) {
        onClick(e);
      }
    },
    [onClick, timerRef, isLongPressTriggeredRef, isMovementExceededRef],
  );

  return { onPointerDown, onPointerUp };
}
